import Environment from '../../Environment';
import { IFilter, IInclude, IPage, IQuery, buildUrl } from '../BaseService';

export interface IPrepareTagUrl {
  filters?: IFilter[];
  id?: string;
  includes?: IInclude[];
  pages?: IPage[];
  queries?: IQuery[];
}

export function prepareTagUrl({
  filters,
  id,
  includes,
  pages,
  queries,
}: IPrepareTagUrl): string {
  return buildUrl({
    filters,
    host: Environment.tagHost,
    id,
    includes,
    pages,
    resource: 'tag',
    queries,
  });
}
